import React from 'react';
import { typeMeta } from '../constants/supportCases';
import { CaseTypeIcon } from './icons';
import './SupportCaseTypeBadge.css';

/**
 * Color-coded pill for a support case's type (bug / question / feature request),
 * used in the case lists and detail views for quick visual distinction.
 */
function SupportCaseTypeBadge({ type }) {
  const meta = typeMeta(type);
  return (
    <span className={`support-case-type ${meta.badgeClass}`}>
      <CaseTypeIcon type={type} size={13} className="support-case-type-icon" />
      {meta.label}
    </span>
  );
}

export default SupportCaseTypeBadge;
